/*
 * Split out of NeighbourLettersTool when wrapping it for Spanish (ADR 0325)
 * took that file past the 500-line limit.
 */

import { ErrorNote } from "../../components/ui";
import { t, tn } from "../../i18n";
import type { pilotNeighbourLookup } from "../../lib/queries";

/** What a pilot lookup found, for reading down before the switch is ticked. */
export function PilotResult({
  result,
}: {
  result: Awaited<ReturnType<typeof pilotNeighbourLookup>>;
}) {
  if (result.error) return <ErrorNote error={result.error} />;
  const addresses = result.addresses ?? [];
  return (
    <div className="block">
      <div className="muted">
        {tn(
          result.requests ?? 0,
          "{shown} of {found} properties found, in 1 request.",
          "{shown} of {found} properties found, in {n} requests.",
          { shown: addresses.length, found: result.found ?? 0 },
        )}
      </div>
      <div className="ewrap">
        <table className="etable" aria-label={t("Addresses found")}>
          <thead>
            <tr>
              <th>{t("Address")}</th>
              <th>{t("Town")}</th>
              <th>{t("Kind")}</th>
              <th className="num">{t("Miles")}</th>
            </tr>
          </thead>
          <tbody>
            {addresses.map((address) => (
              <tr key={`${address.line1}-${address.postalCode ?? ""}`}>
                <td>
                  {address.line1}
                  {address.incomplete && (
                    <span className="na-hint">
                      {" · " + t("address incomplete")}
                    </span>
                  )}
                </td>
                <td>
                  {[address.city, address.state, address.postalCode]
                    .filter(Boolean)
                    .join(" ") || "—"}
                </td>
                <td>{address.propertyType ?? "—"}</td>
                <td className="num">{address.distanceMiles.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
